const PageTitle = ({ backLink, title, second, noTitle }) => { // second è l'eventuale stringa di mezzo
    return (
        <div className="flex flex-col gap-2 mb-8 w-full items-center">
            {!noTitle && <h2>{title}</h2>}
        </div>
    )
}

export default PageTitle;